import { Text } from '@components/primitives/Text'
import hashCode from '@lib/utilities/number/hashCode'
import type { DrugApprovedUse } from '@modules/drugs/helpers/getTreatmentPageData'

export const FDAApprovedTemplateString = ({
  brandName,
  drugApprovedUses,
  drugName,
}: {
  brandName?: string
  drugApprovedUses: DrugApprovedUse[]
  drugName: string
}) => {
  // This will allow us to make consistent strings for each drug, but then the permutations of the string will be random for each drug
  const noise = hashCode(drugName).toString().split('').map(Number)

  const suchAs = ['including', 'which include', 'like', 'such as']
  const knownAs = [
    'otherwise known as',
    'also known as',
    'also called',
    'otherwise called',
    'commonly known as',
  ]

  const template = `${drugName}, ${knownAs[noise[1]! % knownAs.length]} ${
    brandName ?? drugName
  }, is approved by the FDA for ${drugApprovedUses.length} uses ${
    suchAs[noise[2]! % suchAs.length]
  } ${drugApprovedUses[0]?.conditionName}${
    drugApprovedUses[1]?.conditionName
      ? ` and ${drugApprovedUses[1]?.conditionName}`
      : ''
  } .`

  return (
    <Text className='my-2 text-dark' styleName={'p-small'} value={template} />
  )
}
